import firebase from 'firebase';
import 'firebase/firestore';

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyAa3x4kmcBoBB53gUzv_1fhuu3XTHszXrg',
  authDomain: 'iberkut-3504c.firebaseapp.com',
  databaseURL: 'https://iberkut-3504c.firebaseio.com',
  projectId: 'iberkut-3504c',
  storageBucket: 'iberkut-3504c.appspot.com',
  messagingSenderId: '251211630135'
};

firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;

// firebase collections
const usersCollection = db.collection('users');

export default {
  db,
  auth,
  currentUser,
  usersCollection
};
